<template>
  <div :class="`cp-utilities-generic_modal-wrapper ${isModalCurrentlyOpen ? 'open' : 'closed'}`">
    <div class="cp-utilities-generic_modal-overlay">
      <svg class="cp-utilities-generic_modal-overlay-static" xmlns="http://www.w3.org/2000/svg">
        <filter :id="getMyId">
          <feTurbulence type="fractalNoise" baseFrequency="0.68" numOctaves="1" stitchTiles="stitch" />
        </filter>
        <rect width="100%" height="100%" :filter="`url(#${getMyId})`" />
      </svg>
    </div>
    <button
      :style="`color: ${closeBtnColor}`"
      class="cp-utilities-generic_modal-overlay-close"
      type="button"
      aria-label="Close"
      @click="closeModal"
    >
      <span v-html="getExitModalIcon"></span>
    </button>
    <div class="cp-utilities-generic_modal"
         :style="`width:${width}; height:${height}; max-height: ${maxHeight}; max-width: ${maxWidth}`"
    >
      <div v-if="hasHeader" class="cp-utilities-generic_modal-header">
        <slot name="header" />
      </div>
      <div class="cp-utilities-generic_modal-body">
        <slot />
      </div>
      <div v-if="hasFooter" class="cp-utilities-generic_modal-footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'GenericModal',
  props: {
    shouldModalStartInOpenState: {
      type: Boolean,
      required: false,
      default: false
    },
    uniqueId: {
      type: String,
      required: true
    },
    closeBtnColor: {
      type: String,
      required: false,
      default: '#9A9A9B'
    },
    hasHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    hasFooter: {
      type: Boolean,
      required: false,
      default: true
    },
    openDispatchEvent: {
      type: String,
      required: false
    },
    closeDispatchEvent: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    maxWidth: {
      type: String,
      required: false,
      default: '1190px'
    },
    maxHeight: {
      type: String,
      required: false,
      default: '680px'
    }
  },
  data () {
    return {
      isModalCurrentlyOpen: false
    }
  },
  computed: {
    getMyId () {
      return this.uniqueId
    },
    getExitModalIcon () {
      return '<i class="lni lni-close"></i>'
    }
  },
  mounted () {
    this.isModalCurrentlyOpen = this.shouldModalStartInOpenState
  },
  created () {
    this.$root.$on('modal-open', this.openModal)
    this.$root.$on('modal-close', this.closeModal)
  },
  methods: {
    async openModal () {
      this.isModalCurrentlyOpen = true
      if (this.openDispatchEvent !== undefined) {
        await this.$store.dispatch(this.openDispatchEvent)
      }
    },
    async closeModal () {
      this.isModalCurrentlyOpen = false
      if (this.closeDispatchEvent !== undefined) {
        await this.$store.dispatch(this.closeDispatchEvent)
      }
    }
  }
}
</script>

<style lang="scss">

$transitional-profile-1: all .2s ease-out;

.cp-utilities-generic_modal {
  visibility: hidden;
  content-visibility: hidden;
  z-index: 9002;

  &-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: $transitional-profile-1;
    pointer-events: none;
    user-select: none;
    display: grid;
    align-items: center;
    align-content: center;
    justify-items: center;
    justify-content: center;
    z-index: 9000;
    transition: all 0.5s ease;
    &.open {
      opacity: 1;
      pointer-events: auto;
      user-select: initial;

      .cp-utilities-generic_modal {
        visibility: visible;
        content-visibility: visible;
        position: fixed;
        display: grid;
        align-items: center;
        width: 100%;
        height: 100%;
        max-height: 680px;
        max-width: 1190px;
        padding: 1rem;
        background: white;
        border-radius: 10px;
        @media screen and (max-width: 1200px) {
          max-height: unset;
        }
        @media screen and (max-width: 767px) {
          max-width: 100%!important;
          padding: 0;
        }
      }
    }
  }
  &-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(1rem);
    opacity: 1;
    background-color: rgb(176 144 153 / 38%);
    z-index: 1001;
    transition: $transitional-profile-1;

    &-static {
      width: 100%;
      height: 100%;
      opacity: 0.23;
    }

    &-close {
      background: white;
      border-radius: 20px;
      border: none;
      position: absolute;
      top: 1rem;
      right: 1rem;
      cursor: pointer;
      color: #ef1b1b;
      z-index: 9999;
      transition: $transitional-profile-1;
      span {
        i {
          font-weight: 900;
        }
      }
      &:hover {
        transform: scale(1.5);
      }
      &:active {
        transform: scale(0.8);
      }
    }
  }
  &-body {
    display: grid;
    transition: all 0.5s ease;
  }
}
</style>
